import Joi from 'joi';

export const LawSchema = Joi.object({
  title: Joi.string().required(),
  pined: Joi.string().required(),
  file: Joi.string().required(),
});
